<div class="tracking-details-dialog ups-dialog">
    <div class="dialog-header">
        <h2 mat-dialog-title>{{'TrackingDetails'|translate}}</h2>
        <mat-dialog-actions>
        </mat-dialog-actions>
        <button type="button" mat-raised-button class="icon-button close-button" mat-dialog-close>
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <mat-dialog-content>
        <upsc-ship-details [shipmentPackage]="shipmentPackage"
                           [shipmentType]="shipmentType"
                           [isTrackedShipment]="true"></upsc-ship-details>
    </mat-dialog-content>
</div>
